import type { UpsellPageDTO } from "../../types/upsell.types";
import { SingleSectionUpsell } from "./SingleSectionUpsell";
import { MultipleSectionUpsell } from "./MultipleSectionUpsell";

type UpsellPageRendererProps = {
  data: UpsellPageDTO;
  countdownText: string;
  isCountdownExpired: boolean;
};

export const UpsellPageRenderer = ({
  data,
  countdownText,
  isCountdownExpired,
}: UpsellPageRendererProps) => {
  if (data.layout_variant === "multiple_products") {
    return (
      <MultipleSectionUpsell
        data={data}
        countdownText={countdownText}
        isCountdownExpired={isCountdownExpired}
      />
    );
  }

  return <SingleSectionUpsell data={data} />;
};
